module.exports = __webpack_public_path__ + "static/media/finish_line_2.d8fe545e.svg";